import moment from 'moment'
import { dateField, notesKeys } from '../constants/index'

const validateDate = (dateString) => {
  return moment(dateString).isValid() ? dateString : ''
}

const validateNotes = (notesString) => {
  const sanitizedString = notesString
    ?.replace(/\/|\\|"/g, '')
    ?.replace(/----/g, '')
    ?.replace(/[\r\n]+/g, '')
    ?.trim()

  return sanitizedString
}

export function validatePayloadDates(payload) {
  if (Array.isArray(payload)) {
    return payload.map((item) => validatePayloadDates(item))
  } else if (typeof payload === 'object' && payload !== null) {
    Object.keys(payload).forEach((key) => {
      if (Object.values(dateField).includes(key)) {
        if (payload[key]) payload[key] = validateDate(payload[key])
      } else if (notesKeys.includes(key)) {
        if (payload[key]) payload[key] = validateNotes(payload[key])
      } else if (typeof payload[key] === 'object') {
        validatePayloadDates(payload[key])
      }
    })
  }
  return payload
}
